import { useEffect, useState } from 'react';
import { pagesDuSiteService } from '../services/pagesDuSiteService';

// Repli tant qu'aucun guide « principal » n'est administre dans le BO, ou si l'appel echoue.
export const GUIDE_PDF_REPLI = "/pdfs/guides/25-12-12 Guide d'utilisation V3.pdf";

// Le lien « Guide methodologique » existe a deux endroits montes ensemble (footer + menu de la navbar).
// Source unique : meme URL, meme repli, et UNE requete par chargement au lieu d'une par emplacement.
// Fraicheur : le BO peut remplacer le guide pendant qu'un onglet reste ouvert des heures ; l'ancien
// fichier n'existe alors plus et le lien memorise casse. On relit donc au retour sur l'onglet, au plus
// une fois toutes les 5 minutes.
const FRAICHEUR_MS = 5 * 60 * 1000;

let cache: { url: string; at: number } | null = null;
let enCours: Promise<string> | null = null;
const abonnes = new Set<(url: string) => void>();

function charger(): Promise<string> {
  if (cache && Date.now() - cache.at < FRAICHEUR_MS) {
    return Promise.resolve(cache.url);
  }
  if (!enCours) {
    enCours = pagesDuSiteService
      .getGuidePrincipal()
      .then((g) => ({ url: g?.pdf_url || GUIDE_PDF_REPLI, at: Date.now() }))
      // Echec reseau : on garde la derniere URL connue (sinon le repli) et at = 0 pour retenter au prochain appel.
      .catch(() => ({ url: cache?.url ?? GUIDE_PDF_REPLI, at: 0 }))
      .then((resultat) => {
        cache = resultat;
        enCours = null;
        abonnes.forEach((notifier) => notifier(resultat.url));
        return resultat.url;
      });
  }
  return enCours;
}

/** URL du guide methodologique administre en BO (guide marque « principal »), avec repli statique. */
export function useGuidePrincipalUrl(): string {
  const [url, setUrl] = useState<string>(cache?.url ?? GUIDE_PDF_REPLI);

  useEffect(() => {
    abonnes.add(setUrl);
    charger();
    const auRetourSurLOnglet = () => {
      if (document.visibilityState === 'visible') {
        charger();
      }
    };
    document.addEventListener('visibilitychange', auRetourSurLOnglet);
    return () => {
      abonnes.delete(setUrl);
      document.removeEventListener('visibilitychange', auRetourSurLOnglet);
    };
  }, []);

  return url;
}
